import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ImageThumbnailComponent } from '@web/shared/ui';

@Component({
  selector: 'app-public-highlighted-brand-tile',
  imports: [ImageThumbnailComponent, NgOptimizedImage],
  templateUrl: './public-highlighted-brand-tile.component.html',
  styleUrl: './public-highlighted-brand-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicHighlightedBrandTileComponent {
  public readonly name = input.required<string>();
  public readonly logoAlt = input.required<string>();
  public readonly logoSrc = input.required<string>();

  @HostBinding('attr.title')
  public get title(): string {
    return this.name();
  }
}
